import React from 'react'
 import { FaSearch } from "react-icons/fa"; 


export const Mailing = () => {

    return (
        <div className="mailing_list">
            <div>
                <h1 className="title">Are you ready to start?</h1>
                <p className="description">You can see first news with joining our mailing list.</p>
            </div>
            <div className="form">
                <div className="send">
                    <FaSearch />
                    <input placeholder="Email" />
                </div>
                <div className="button">Join</div>
            </div>
        </div>
    )
} 
